import { getData } from "./index.svc"

export const getCustomers = async (showAll = false) => {
    const qs = showAll ? '?all=1' : ''
    return await getData(`customers${qs}`)
}

export const createCustomer = async (body) => {
    return await getData('customers', 'POST', body)
}

export const updateCustomer = async(id, body) => {
    return await getData(`customers/${id}`, 'POST', body)
}

export const deleteCustomer = async(id) => {
    return await getData(`customers/${id}?Active=No`, 'DELETE')
}

export const resetCustomer = async(id) => {
    return await getData(`customers/${id}?Active=Yes`, 'DELETE')
}